<template>
  <div class="m-t-20">
    <div class="card">
      <!----谈判采购信息------>
      <div v-if="showOrder" class="section">
        <div class="section-title">
          <base-section-title title="谈判采购信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="orderInfo"
            :option="orderOptions"
            :el-attrs="{
              size: 'medium',
              column: 1,
              labelStyle: {
                width: '140px',
                whiteSpace: 'nowrap',
                textAlign: 'right'
              }
            }"
          >
            <template v-slot:budgetAmountWy="{ value }">
              <span>{{ value ? strToThousands(value) : '-' }} 万元</span>
              <money-in-cn :money="value" :multiple="10000" />
            </template>
          </jczh-descriptions>
        </div>
      </div>

      <!---流标处理--->
      <div class="card no-padding-bottom">
        <div class="section">
          <div class="section-title">
            <base-section-title title="流标处理" />
          </div>
          <div class="section-content">
            <jczh-descriptions
              :info="auctionInfo"
              :option="contentOptions"
              :el-attrs="{
                size: 'medium',
                column: 1,
                labelStyle: {
                  width: '100px',
                  whiteSpace: 'nowrap',
                  textAlign: 'right'
                }
              }"
            >
              <template v-slot:closeAttachmentIds>
                <upload
                  ref="uploadFile"
                  :file-id-before.sync="auctionInfo.closeAttachmentIds"
                  :props-data="{
                    limit: 10,
                    disabled: true,
                    uploadMode: 'fileId',
                    singleUpload: false
                  }"
                />
              </template>
            </jczh-descriptions>
          </div>
        </div>
      </div>

      <!---免收标书费--->
      <div
        v-if="auctionInfo.closeType === negotiationV2AuctionStatusDict.RESTART.value"
        class="card no-padding-bottom"
      >
        <div class="section">
          <div class="section-title">
            <base-section-title title="免收标书费" />
          </div>
          <div class="section-content">
            <jczh-descriptions
              :info="auctionInfo"
              :option="bidFeeOptions"
              :el-attrs="{
                size: 'medium',
                column: 1,
                labelStyle: {
                  width: '100px',
                  whiteSpace: 'nowrap',
                  textAlign: 'right'
                }
              }"
            />
          </div>
        </div>
      </div>

      <!---流标公告--->
      <div class="card">
        <div class="section">
          <div class="section-title">
            <base-section-title title="流标公告" />
          </div>
          <div class="section-content">
            <jczh-descriptions
              :info="auctionInfo"
              :option="noticeOptions"
              :el-attrs="{
                size: 'medium',
                column: 1,
                labelStyle: {
                  width: '100px',
                  whiteSpace: 'nowrap',
                  textAlign: 'right'
                }
              }"
            >
              <template v-slot:content>
                <u-editor
                  v-if="auctionInfo.content"
                  disabled
                  :value="auctionInfo.content"
                />
                <span v-else>-</span>
              </template>
            </jczh-descriptions>
          </div>
        </div>
      </div>

      <!-- 审批备注 -->
      <record-remark
        v-if="requestQuery.pageFrom == 'auditDetail'"
        :remark-list="remarkList"
      />

      <!-- 审批历史 -->
      <record-history
        v-if="requestQuery.pageFrom == 'auditDetail'"
        :record-list="auctionInfo.flowListing"
      />
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'
import RecordHistory from '@/components/common/RecordHistory'
import RecordRemark from '@/components/common/RecordRemark'
import MoneyInCn from '@/components/common/MoneyInCn'
import Upload from '@/components/common/Upload/index.vue'

import {
  projectTypeDict,
  projectAssetDisposalMethodDict,
  releaseMediaDict,
  noticeReleaseStatusDict,
  flowMarkDict
} from '@/dictionary/project/common'
import {
  negotiateMethodDict,
  negotiationV2AuctionStatusDict,
  isPublicPublishDict,
  negotiationBookFeeStatusDict
} from '@/dictionary/project/negotiation-v2'

import {
  getLatestAuctionApi,
  getNegotiationV2DetailApi
} from '@/api/procure/negotiation-v2'

import DateUtils from '@/utils/date'
import { strToThousands } from '@/utils/utils'
export default {
  components: {
    BaseSectionTitle,
    UEditor,
    RecordHistory,
    RecordRemark,
    MoneyInCn,
    Upload
  },

  props: {
    requestQuery: {
      type: Object,
      required: true
    },

    showOrder: {
      type: Boolean,
      default: true
    },

    isByOrderId: {
      type: Boolean,
      default: true
    },

    // 备注列表
    remarkList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data() {
    return {
      negotiationV2AuctionStatusDict,
      orderInfo: {},
      auctionInfo: {}
    }
  },

  computed: {
    orderId() {
      return this.requestQuery.orderId
    },

    // 谈判单信息
    orderOptions() {
      return [
        { label: '谈判采购名称', prop: 'orderName', elAttrs: { span: 3 } },
        { label: '谈判采购编号', prop: 'customOrderCode' },
        {
          label: '谈判采购预算',
          prop: 'budgetAmountWy',
          slotName: 'budgetAmountWy'
        },
        {
          label: '报名时间',
          prop: '',
          filter: value =>
            DateUtils.getNormMinuteRange(
              value.offerStartTime,
              value.offerEndTime
            )
        },
        {
          label: '提交响应文件截止时间',
          prop: 'negotiateTime',
          isNormMinute: true
        },
        {
          label: '项目类型',
          prop: 'projectType',
          filter: value => projectTypeDict.translate(value).label
        },
        {
          label: '处置方式',
          prop: 'assetDisposalMethod',
          filter: value =>
            projectAssetDisposalMethodDict.translate(value)?.label ||
            projectAssetDisposalMethodDict.EXPENDITURE.label,
          hideFun: () =>
            this.orderInfo.projectType !== projectTypeDict.ASSET_DISPOSAL.value
        },
        {
          label: '发布媒体',
          prop: 'noticeMedium',
          filter: value => {
            const temp = (value || '').split(',')
            return (
              temp
                .map(mediumValue => {
                  return releaseMediaDict.translate(
                    this.purchaseNotice?.noticeMedium
                  )?.label
                })
                .filter(value => value)
                .join('、') || '-'
            )
          }
        },
        {
          label: '谈判方式',
          prop: 'negotiateMethod',
          filter: value => negotiateMethodDict.translate(value).label || '-'
        },
        {
          label: '谈判地点',
          prop: '',
          filter: value =>
            `${value?.province} - ${value?.city} - ${value?.area}`
        },
        { label: '详细地址', prop: 'address' }
      ]
    },

    // 流标内容
    contentOptions() {
      return [
        {
          label: '是否对外发布',
          prop: 'closePublicity',
          filter: value => isPublicPublishDict.translate(value).label
        },
        {
          label: '流标状态',
          prop: 'closeType',
          filter: value => negotiationV2AuctionStatusDict.translate(value).label
        },
        {
          label: '流标原因',
          prop: 'closeReason',
          filter: value => flowMarkDict.translate(value).label
        },
        {
          label: '其他原因',
          prop: 'otherReason',
          hideFun: () =>
          this.auctionInfo?.closeReason !== flowMarkDict.OTHER.value
        },
        { label: '说明文件', slotName: 'closeAttachmentIds' }
      ]
    },

    // 标书费信息
    bidFeeOptions() {
      return [
        {
          label: '是否免收标书费',
          prop: 'fileFeeFree',
          filter: value => negotiationBookFeeStatusDict.translate(value).label
        }
      ]
    },

    // 发布内容
    noticeOptions() {
      return [
        {
          label: '发布状态',
          prop: 'releaseStatus',
          dictArray: noticeReleaseStatusDict.array,
          useTag: true
        },
        {
          label: '公告标题',
          prop: 'title'
        },
        {
          label: '公告内容',
          prop: 'content',
          slotName: 'content'
        }
      ]
    }
  },

  watch: {
    'requestQuery.orderInfo': {
      handler: function(val) {
        if (val) {
          this.orderInfo = this.requestQuery?.orderInfo || {}
        }
      },
      immediate: true
    },

    'requestQuery.orderId': {
      handler: function(val) {
        this.getAuction()
        if (this.isByOrderId && val) {
          this.getOrderInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,

    // 获取详情信息
    async getOrderInfo() {
      if (!this.orderId) return
      try {
        const { data } = await getNegotiationV2DetailApi(this.orderId)
        this.orderInfo = data?.orderInfo || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 获取流标
     */
    getAuction() {
      if (!this.orderId) return
      this.getLatestAuction()
    },

    /**
     * 获取最新流标信息
     */
    async getLatestAuction() {
      try {
        const _data = await getLatestAuctionApi(this.orderId)
        const data = _data.data || {}
        const { notice, ...other } = data
        this.auctionInfo = { ...notice, ...other }
        if (this.auctionInfo.closeReason === flowMarkDict.OTHER.value) {
          this.contentOptions[3] = {
            label: '其他原因',
            prop: 'otherReason'
          }
        }
        this.$emit('setCloseId', this.auctionInfo.closeId)
        this.$emit('setAuctionInfo', this.auctionInfo)
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
